import i18n from '@/libs/i18n'

export default [
  {
    title: i18n.messages.Productos,
    route: "products",
    icon: "SearchIcon",
  }
];
